<template>
  <app-modal
    ref="modal"
    v-bind="$attrs"
    class="modal-container"
    content-class="modal-medium"
    title="IP Pool設定参照"
  >
    <template v-slot:body="{ cancel }">
      <v-card-text class="pa-0">
        <div class="modal-body">
          <v-container>
            <v-row>
              <v-col class="text-right">
                <v-btn
                  v-permission.config
                  color="primary"
                  @click="showModifyIpPoolModal"
                >
                  変更
                </v-btn>

                <v-btn
                  v-if="!ipPool.isPolicyInUse"
                  v-permission.config
                  color="primary"
                  @click="deleteIpPool"
                  class="ml-2"
                  >削除</v-btn
                >
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <app-label-group label="名前" :value="ipPool.ipPoolName" />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <app-label-group
                  label="グローバルIP"
                  :value="ipPool.globalIpAddress"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <app-label-group
                  label="備考"
                  :value="$filter.emptyTo(ipPool.description, '-')"
                  class="text-pre-wrap"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <app-label-group
                  label="ポリシー使用有無"
                  :value="$filter.enumTo(ipPool.isPolicyInUse, 'isPolicyInUse')"
                />
              </v-col>
            </v-row>
          </v-container>
        </div>
      </v-card-text>
      <v-divider></v-divider>

      <v-card-actions>
        <v-list-item class="w-100 pa-1">
          <template v-slot:append>
            <v-btn @click="cancel" variant="outlined" color="primary"
              >戻る</v-btn
            >
          </template>
        </v-list-item>
      </v-card-actions>
    </template>
  </app-modal>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import type { PropType } from "vue";
import { VueFinalModal } from "vue-final-modal";
import type { IpPool, IpPoolDelete } from "@/apis/IpPoolApi";
import IpPoolEdit from "@/modals/applianceObject/IpPoolEdit.vue";

export default defineComponent({
  name: "IpPoolReference",
  props: {
    ipPool: {
      type: Object as PropType<IpPool>,
      required: true,
    },
    ipPoolKeyId: {
      type: String as PropType<string>,
      required: true,
    },
    type4Id: {
      type: String as PropType<string>,
      required: false,
      default: null,
    },
  },
  methods: {
    /**
     * IP Poolの削除処理
     */
    async deleteIpPool(): Promise<void> {
      // ポリシー設定有無が有りの場合は処理を終了
      if (this.ipPool.isPolicyInUse) return;

      // 確認ダイアログの表示
      await this.$confirm("IP Poolを削除します。よろしいですか？");

      // リクエスト用データの作成
      const reqData: IpPoolDelete = {
        ipPoolList: [this.ipPool.ipPoolSeq],
        note: null,
        ipPoolKeyId: this.ipPoolKeyId,
      };

      // IP Pool削除APIを呼び出す
      if (!this.type4Id) {
        await this.$api.ipPool.deleteIpPoolType1(reqData);
      } else {
        await this.$api.ipPool.deleteIpPoolType4(reqData, this.type4Id);
      }
      (this.$refs.modal as typeof VueFinalModal & { ok: () => void }).ok();
    },
    /**
     * 変更モーダルを表示する
     */
    async showModifyIpPoolModal(): Promise<void> {
      await this.$modal.show(IpPoolEdit, {
        ipPool: this.ipPool,
        ipPoolKeyId: this.ipPoolKeyId,
        type4Id: this.type4Id,
      });
      (this.$refs.modal as typeof VueFinalModal & { ok: () => void }).ok();
    },
  },
});
</script>
